import React, { Component } from "react"
import { Index } from "elasticlunr"
import { Link } from 'gatsby'

// Search component
class SearchSite extends Component {
  constructor(props) {
    super(props)
    this.state = {
      query: ``,
      results: [],
    }
  }
  renderResults = () => {
    return(
      <p className="result-count" aria-atomic="true" aria-live="polite">
        {this.state.results.length} {this.state.results.length === 1 ? `Result` : `Results`}
      </p>
    )
  }

  render() {
    return (
      <>
        <h2 id="search-overlay-label"><label htmlFor="search-field">Search</label></h2>
        <input ref={this.props.searchInputRef} id="search-field" className="search" type="text" value={this.state.query} onChange={this.search} required />
        <div className="search-results">
          <h2><span className="sr-only">Search </span>Results</h2>
          {this.renderResults()}
          <ul>
            {this.state.results.map(page => (
              <li className="result-item" key={page.id}>
                <h3>
                  <Link to={page.path}>{page.title}</Link>
                </h3>
                <p>{page.path}</p>
              </li>
            ))}
          </ul>
        </div>
      </>
    )
  }
  getOrCreateIndex = () =>
    this.index
      ? this.index
      : // Create an elastic lunr index and hydrate with graphql query results
        Index.load(this.props.searchIndex)

  search = evt => {
    const query = evt.target.value
    this.index = this.getOrCreateIndex()
    this.setState({
      query,
      // Query the index with search string to get an [] of IDs
      results: this.index
        .search(query, {})
        // Map over each ID and return the full document
        .map(({ ref }) => this.index.documentStore.getDoc(ref)),
    })
  }
}

// Forward search input field reference to use as initial focus element
export default React.forwardRef((props, ref) => <SearchSite searchInputRef={ref} {...props}/>);